import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import { NetworkTiles } from './tiles.configurations'
import {
  NetworkTableTab,
  NetworkTileType
} from '@src/endpoints/services/graphQueryMgr.service'

/* eslint-disable import/prefer-default-export */
export enum NetworkTabs {
  Users,
  Roles,
  Groups,
  Instance,
  SecurityGroups,
  Subnets,
  Rules,
  Routes,
  Objects,
  Total,
  Used
}

export const getTabs = (tile: NetworkTiles, type: ResourceTypeEnum) => {
  switch (tile) {
    case NetworkTiles.Objects:
    case NetworkTiles.Roles:
      return [NetworkTabs.Total, NetworkTabs.Used]
    case NetworkTiles.IAM:
      return [NetworkTabs.Users, NetworkTabs.Roles, NetworkTabs.Groups]
    case NetworkTiles.Networking: {
      switch (type) {
        case ResourceTypeEnum.VPC:
          return [
            NetworkTabs.Instance,
            NetworkTabs.SecurityGroups,
            NetworkTabs.Subnets
          ]
        case ResourceTypeEnum.SUBNET:
          return [NetworkTabs.Instance, NetworkTabs.SecurityGroups]
        case ResourceTypeEnum.SECURITY_GROUP:
          return [NetworkTabs.Instance, NetworkTabs.Rules]
        case ResourceTypeEnum.ROUTE_TABLE:
          return [NetworkTabs.Instance, NetworkTabs.Subnets, NetworkTabs.Routes]
        default:
          return []
      }
    }
    default:
      return []
  }
}

export const tabsConfig = {
  [NetworkTabs.Users]: {
    tableTab: NetworkTableTab.TABLE_TAB_IAM_USER,
    tile: NetworkTileType.TILE_NETWORK_IAM
  },
  [NetworkTabs.Roles]: {
    tableTab: NetworkTableTab.TABLE_TAB_IAM_ROLE,
    tile: NetworkTileType.TILE_NETWORK_IAM
  },
  [NetworkTabs.Groups]: {
    tableTab: NetworkTableTab.TABLE_TAB_IAM_GROUP,
    tile: NetworkTileType.TILE_NETWORK_IAM
  },
  [NetworkTabs.Instance]: {
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_INSTANCES,
    tile: NetworkTileType.TILE_NETWORK_NETWORKING
  },
  [NetworkTabs.SecurityGroups]: {
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_SECURITY_GROUPS,
    tile: NetworkTileType.TILE_NETWORK_NETWORKING
  },
  [NetworkTabs.Subnets]: {
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_SUBNETS,
    tile: NetworkTileType.TILE_NETWORK_NETWORKING
  },
  [NetworkTabs.Rules]: {
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_RULES,
    tile: NetworkTileType.TILE_NETWORK_NETWORKING
  },
  [NetworkTabs.Routes]: {
    tableTab: NetworkTableTab.TABLE_TAB_NETWORKING_ROUTES,
    tile: NetworkTileType.TILE_NETWORK_NETWORKING
  }
}

export enum TabFromTilesDataMapper {
  users = NetworkTabs.Users,
  roles = NetworkTabs.Roles,
  groups = NetworkTabs.Groups,
  instances = NetworkTabs.Instance,
  securityGroups = NetworkTabs.SecurityGroups,
  subnets = NetworkTabs.Subnets,
  sgRules = NetworkTabs.Rules,
  routes = NetworkTabs.Routes,
  objects = NetworkTabs.Objects,
  total = NetworkTabs.Total,
  used = NetworkTabs.Used
}

export const CounterFromTab = {
  [NetworkTabs.Users]: 'users',
  [NetworkTabs.Groups]: 'groups',
  [NetworkTabs.Roles]: 'roles',
  [NetworkTabs.Instance]: 'instances',
  [NetworkTabs.SecurityGroups]: 'securityGroups',
  [NetworkTabs.Subnets]: 'subnets',
  [NetworkTabs.Rules]: 'sgRules',
  [NetworkTabs.Used]: 'used',
  [NetworkTabs.Total]: 'total'
}
